import { render, staticRenderFns } from "./tags_library.vue?vue&type=template&id=810f3e6e"
import script from "./tags_library.vue?vue&type=script&lang=ts"
export * from "./tags_library.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports